module.exports = __webpack_public_path__ + "img/NC_logo_dark.c6162be4.svg";